export const baseURL = process.env.REACT_APP_BASE_URL;
export const askAllamaBaseURL = process.env.REACT_APP_ASK_ALLAMA_URL;
export const socBaseURL = process.env.REACT_APP_SOCKET_URL

export const fetchWORKerDetails = "/fetchWORKerDetails";
export const fetchStates = "/fetchStates";
export const fetchDistricts = "/fetchDistricts";
export const addNewDistrictLeader = "/addNewDistrictLeader";
export const fetchSupervisorDetailsForDistrict =
	"/fetchSupervisorDetailsForDistrict";
export const getDistrictAvailability = "/getDistrictAvailibility";

export const getWORKerDetails = "/getWORKerDetails";
export const fetchAssignmentTableData = "/fetchTableData";
export const makeOrRemoveLeader = "/makeOrRemoveLeader";
export const addNewSupervisor = "/addNewSupervisor";
export const getWORKersForAlliance = "/getWORKersForAlliance";
export const getLeadersList = "/getLeadersList";
export const getSupervisorsList = "/getSupervisorsList";

export const fetchAllianceList = "/fetchAllianceList";
export const fetchAllianceMemberDetails = "/fetchAllianceMemberDetails";
export const addNewMemberIntoAlliance = "/addNewMemberIntoAlliance";
export const updateLeader = "/updateLeader";
export const deleteMemberFromAlliance = "/deleteMemberFromAlliance";

export const fetchLeadersWithoutAcc = "/fetchLeadersWithoutAcc";
export const createNewLeaderAccount = "/createNewLeaderAccount";

export const createAlliance = "/createNewAlliance";
export const fetchOneTimeTasks = "/fetchOneTimeTasks";
export const fetchDailyTasks = "/fetchDailyTasks";
export const fetchWeeklyTasks = "/fetchWeeklyTasks";
export const fetchMonthlyTasks = "/fetchMonthlyTasks";
export const districtsPickedCount = "/districtsPickedCount";

export const customDownloadDailyTasks = "/customDownloadDailyTasks";

export const login = "/login";
export const signup = "/signup";

export const oneTimeTaskApi = "/addOneTimeTask";
export const dailyTaskApi = "/addDailyTask";
export const weeklyTaskApi = "/addWeeklyTask";
export const monthlyTaskApi = "/addMonthlyTask";

export const fetchWeeklyTaskDetails = "/fetchWeeklyTaskDetails";
export const fetchOneTimeTaskDetails = "/fetchOneTimeTaskDetails";
export const fetchDailyTaskDetails = "/fetchDailyTaskDetails";
export const fetchMonthlyTaskDetails = "/fetchMonthlyTaskDetails";

export const createMemberAccount = "/createMemberAccount";

export const memberLogin = "/memberLogin";
export const resetPassword = "/reset-password";
export const deleteMemberAccount = "/deleteMemberAccount";

export const fetchDailyTasksList = "/fetchDailyTasksList";
export const addDailyTasks = "/addDailyTasks";

export const getReferals = "/getReferals";
export const updateReferalLeadStatus = "/updateReferalLeadStatus";
export const addNewLead = "/addNewLead";

export const fetchLeadsTableData = "/fetchLeadsTableData";
export const unAssignDistrict = "/unAssignDistrict";

export const getLeadsTiles = "/getLeadsTiles";
export const getUnAssignedLeads = "/getUnAssignedLeads";
export const getAllSupervisors = "/getAllSupervisors";
export const getTLForSupervisor = "/getTLForSupervisor";
export const getInchargeForLeaders = "/getInchargeForLeaders";
export const getTransferredLeads = '/getTransferredLeads'
export const getWORKersByNameAndContact = '/getWORKersByNameAndContact'
export const transferLeads = '/transferLeads'
export const getDistrictWisLeadsHorizontalBar = '/getDistrictWisLeadsHorizontalBar'
export const fetchStatesWithLeads = '/fetchStatesWithLeads'
export const fetchStatesWithLeadsDash = '/fetchStatesWithLeadsDash'
export const fetchDistrictsWithLeads = '/fetchDistrictsWithLeads'
export const fetchLeadsUnderDistrict = '/fetchLeadsUnderDistrict'
export const getCallerPerformance = '/getCallerPerformance'

export const getStatesList = "/getStatesList";
export const getDistrictsList = "/getDistrictsList";

export const fetchMissingDailyTasks = "/fetchMissingDailyTasks";

export const fetchWORKers = '/fetchWORKers'
export const getMemCardStatus = '/getMemCardStatus'
export const updateWORKerDetails = '/updateWORKerDetails'
export const getWORKerImage = '/getWORKerImage'
export const getWORKerImageDashboard = '/getWORKerImageDashboard'
export const fetchPhotoVerfRequests = '/fetchPhotoVerfRequests'
export const updatePhotoVerfStatus = '/updatePhotoVerfStatus'
export const getMemCardStatusDB = '/getMemCardStatusDB'
export const getWORKerHeadsDetails = '/getWORKerHeadsDetails'
export const getAllStates = '/getAllStates'
export const getAllDistrictsForState = '/getAllDistrictsForState'
export const addNewWORKer = '/addNewWORKer'

export const fetchChapters = '/fetchChapters'
export const getIndianStates = '/getIndianStates'
export const getWORKerObligationAndAccountDetails = '/getWORKerObligationAndAccountDetails'
export const fetchSHDHLeads = '/fetchSHDHLeads'
export const fetchStatesForHead = '/fetchStatesForHead'
export const fetchDistrictsForHead = '/fetchDistrictsForHead'
export const addNewLeadTemplate = '/addNewLeadTemplate'
export const getAllLeadTemplates = '/getAllLeadTemplates'
export const getWORKersForHead = '/getWORKersForHead'
export const assignLeadToWORKer = '/assignLeadToWORKer'
export const getWORKerLeads = '/getWORKerLeads'
export const updateLeadAssignedToWORKer = '/updateLeadAssignedToWORKer'
export const getSHDHTopWidget = '/getSHDHTopWidget'
export const getStatesWithLeads = '/getStatesWithLeads'
export const getDistrictsWithLeads = '/getDistrictsWithLeads'
export const fetchWORKerAssignedDistrict = '/fetchWORKerAssignedDistrict'

export const getMemberStateHeadDetails = '/getMemberStateHeadDetails'
export const getStateHeadLessStates = '/getStateHeadLessStates'
export const getStateHeadlessDistricts = '/getStateHeadlessDistricts'
export const assignDistrictToStateHead = '/assignDistrictToStateHead'

export const getMembersDistrictHeadDetails = '/getMembersDistrictHeadDetails'
export const getHeadlessStates = '/getHeadlessStates'
export const getHeadlessDistricts = '/getHeadlessDistricts'
export const assignDistrictToHead = '/assignDistrictToHead'

export const addContributionField = '/addContributionField'
export const getContributionFields = '/getContributionFields'
export const getContributionFieldsHierarchy = '/getContributionFieldsHierarchy'
export const getContributionFieldsHierarchyPortal = '/getContrFieldsHierarchyPortal'
export const updateWORKerContFields = '/updateWORKerContFields'
export const editVolunteringDomain = '/editVolunteringDomain'
export const deleteVolunteeringDomain = '/deleteVolunteeringDomain'


export const isAccountCreated = '/isAccountCreated'
export const createHeadAcc = '/createHeadAcc'


export const getNRQuizContactPerson = '/getNRQuizContactPerson'
export const updateParticipantDetails = '/updateParticipantDetails'
export const generateQuizCertificate = '/generateQuizCertificate'

export const fetchAttendancePollTemplates = '/fetchAttendancePollTemplates'
export const fetchPollFields = '/fetchPollFields/id/'
export const checkPollRestricted = '/checkPollRestricted'
export const submitPollResponse = '/submitPollResponse'
export const fetchPollChartsData = '/fetchPollChartsData'
export const fetchPollVotingStats = '/fetchPollVotingStats/id/'
export const fetchPollStateVotingStats = '/fetchPollStateVotingStats/id/'
export const fetchPollDistrictVotingStats = '/fetchPollDistrictVotingStats/id/'
export const fetchPollVotingMembers = '/fetchPollVotingMembers/id/'
export const fetchPollVoteStats = '/fetchPollVoteStats/id/'
export const addAttendancePollTemplate = '/addAttendancePollTemplate'
export const getDistrictWiseWorkerCounts = '/getDistrictWiseWorkerCounts'
export const checkWORKerIsEc = '/checkWORKerIsEc'
export const getWORKersDesignationWise = '/getWORKersDesignationWise'
export const createAnElection = '/createAnElection'
export const voterLogin = '/voterLogin'
export const voterFinalLogin = '/voterFinalLogin'
export const getElectionDetails = '/getElectionDetails/id/'
export const updatePollStatus = '/updatePollStatus'
export const getCandidateAndVoterList = '/getCandidateAndVoterList'
export const castVote = '/castVote'
export const editElection = '/editElection'
export const checkAllVotersVoted = '/checkAllVotersVoted'
export const generateElectionResult = '/GenerateElectionResult'
export const updateWORKerProfile = '/updateWORKerProfile'
export const createNewTask = '/createNewTask'
export const fetchTasksList = '/fetchTasksList'
export const fetchWORKersTasks = '/fetchWORKersTasks'
export const updateTaskStatus = '/updateTaskStatus'
export const updateuserNotfToken = '/updateuserNotfToken'
export const getWORKersTopWidgetCategories = '/getWORKersTopWidgetCategories'
export const getDistrictWiseWORKerType = '/getDistrictWiseWORKerType'
export const getVolunteeringDomainsHierarchy = '/getVolunteeringDomainsHierarchy'
export const createTrainingProgram = '/createTrainingProgram'
export const updateTrainingProgram = '/updateTrainingProgram'
export const createTrainingBatch = '/createTrainingBatch'
export const fetchTrainingBatches = '/fetchTrainingBatches'
export const fetchTrainingClasses = '/fetchTrainingClasses'
export const fetchTrainingProgram = '/fetchTrainingProgram'
export const fetchTrainingProgramsList = '/fetchTrainingProgramsList'
export const fetchProgramWorkers = '/fetchProgramWorkers'
export const getWORKersByTypes = '/getWORKersByTypes'
export const fetchUserTrainingClasses = '/fetchUserTrainingClasses'
export const fetchUserTrainingBatches = '/fetchUserTrainingBatches'
export const fetchCoordinatorTrainingClasses = '/fetchCoordinatorTrainingClasses'
export const fetchCoordinatorTrainingBatches = '/fetchCoordinatorTrainingBatches'
export const fetchClassAttendance = '/fetchClassAttendance'
export const fetchCoordinatorClassAttendance = '/fetchCoordinatorClassAttendance'
export const updateCoordinatorClassAttendance = '/updateCoordinatorClassAttendance'
export const uploadLearningMaterial = '/uploadLearningMaterial'
export const uploadCoordinatorLearningMaterial = '/uploadCoordinatorLearningMaterial'
export const fetchLearningMaterials = '/fetchLearningMaterials'
export const fetchCoordinatorLearningMaterials = '/fetchCoordinatorLearningMaterials'
export const updateTrainingClassStatus = '/updateTrainingClassStatus'
export const fetchBatchAttendance = '/fetchBatchAttendance'
export const updateTrainingBatch = '/updateTrainingBatch'
export const fetchProgramBatches = '/fetchProgramBatches'
export const fetchBatchCoordinators = '/fetchBatchCoordinators'
export const fetchCoordinatorTrainingPrograms = '/fetchCoordinatorTrainingPrograms';
export const fetchCoordinatorProgramQuestions = '/fetchCoordinatorProgramQuestions';
export const createProgramQuestion = '/createProgramQuestion';
export const submitBatchAssessment = '/submitBatchAssessment';
export const startAssessment = '/startAssesment';
export const getAssessmentDetails = '/getAssesmentDetails';
export const fetchBatchAssessmentResults = '/fetchBatchAssessmentResults';
export const fetchProgramQuestions = '/fetchProgramQuestions';


export const search = '/search'

export const generateAnInvite = '/generateAnInvite'
export const fetchInvites = '/fetchInvites'
export const validateRegistrationLink = '/validateRegistrationLink'
export const fetchInviteDetails = '/fetchInviteDetails'
export const register = '/register'
export const fetchRegistrationInviteDetails = '/fetchRegistrationInviteDetails'
export const reviewRegistration = '/reviewRegistration'
export const isRegistrationForm = '/isRegistrationForm'
export const fetchWORKerByCateogary = '/fetchWORKerByCateogary'
export const getRegistrationInviteTopWidget = '/getRegistrationInviteTopWidget'
export const courses = "/courses";
export const coursesStatus = "/courses/status";
export const createCourseQuestion = "/courses/question";
export const fetchCourseQuestions = "/courses/questions";
export const getWORKerQuizAttemptsTiles = "/courses/WORKer-quiz-attempts/tiles";
export const getWORKerQuizAttemptsTable = "/courses/WORKer-quiz-attempts/table";

export const getDistrictTopWidgets = '/getDistrictTopWidgets';
export const getWORKersByCateogary = '/getWORKersByCateogary';
export const getUncategorisedWORKers = '/getUncategorisedWORKers';
export const getStateHeadWorkerCategorization = '/getStateHeadWorkerCategorization';
